import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class MoveImageAction extends AbstractProvidedClass {
    isImageAction = true;
    movedX = 0;
    movedY = 0;

    constructor(provider) {
        super(provider);
    }

    update() {
        let moveX = (this.p.movedX || (this.p.mouseX - this.p.pmouseX)) / this.view.scale;
        let moveY = (this.p.movedY || (this.p.mouseY - this.p.pmouseY)) / this.view.scale;

        if (moveX != 0 || moveY != 0) {
            this.movedX += moveX;
            this.movedY += moveY;
            this.image.move(moveX, moveY);
        }
    }

    finish() {
        this.actions.finish();
    }

    undo() {
        this.image.move(-this.movedX, -this.movedY);
    }

    redo() {
        this.image.move(this.movedX, this.movedY);
    }
}
